import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import '../../styles/logistic/LogisticFaqSection.css';
import { useTranslation } from 'react-i18next';

const LogisticFaqSection: React.FC = () => {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: t('LogisticFaqSection:faq1_question'),
      answer: (
        <>
          {t('LogisticFaqSection:faq1_answer_prefix')}
          <strong>{t('LogisticFaqSection:faq1_answer_strong')}</strong>
          {t('LogisticFaqSection:faq1_answer_suffix')}
        </>
      ),
    },
    {
      question: t('LogisticFaqSection:faq2_question'),
      answer: (
        <>
          {t('LogisticFaqSection:faq2_answer_prefix')}
          <strong>{t('LogisticFaqSection:faq2_answer_strong')}</strong>
          {t('LogisticFaqSection:faq2_answer_suffix')}
        </>
      ),
    },
    {
      question: t('LogisticFaqSection:faq3_question'),
      answer: (
        <>
          <strong>{t('LogisticFaqSection:faq3_answer_strong')}</strong>
          {t('LogisticFaqSection:faq3_answer_suffix')}
        </>
      ),
    },
    {
      question: t('LogisticFaqSection:faq4_question'),
      answer: (
        <>
          {t('LogisticFaqSection:faq4_answer_prefix')}
          <strong>{t('LogisticFaqSection:faq4_answer_strong1')}</strong>
          {t('LogisticFaqSection:faq4_answer_middle')}
          <strong>{t('LogisticFaqSection:faq4_answer_strong2')}</strong>
          {t('LogisticFaqSection:faq4_answer_suffix')}
        </>
      ),
    },
    {
      question: t('LogisticFaqSection:faq5_question'),
      answer: (
        <>
          <strong>{t('LogisticFaqSection:faq5_answer_strong1')}</strong>
          {t('LogisticFaqSection:faq5_answer_middle')}
          <strong>{t('LogisticFaqSection:faq5_answer_strong2')}</strong>
          {t('LogisticFaqSection:faq5_answer_suffix')}
        </>
      ),
    },
    {
      question: t('LogisticFaqSection:faq6_question'),
      answer: (
        <>
          <strong>{t('LogisticFaqSection:faq6_answer_strong')}</strong>
          {t('LogisticFaqSection:faq6_answer_suffix')}
        </>
      ),
    },
    {
      question: t('LogisticFaqSection:faq7_question'),
      answer: (
        <>
          {t('LogisticFaqSection:faq7_answer_prefix')}
          <strong>{t('LogisticFaqSection:faq7_answer_strong')}</strong>
          {t('LogisticFaqSection:faq7_answer_suffix')}
        </>
      ),
    },
    {
      question: t('LogisticFaqSection:faq8_question'),
      answer: (
        <>
          <strong>{t('LogisticFaqSection:faq8_answer_strong')}</strong>
          {t('LogisticFaqSection:faq8_answer_suffix')}
        </>
      ),
    },
  ];

  return (
    <section className="logistic-faq-section">
      <div className="logistic-container">
        <div className="logistic-section-header">
          <span className="logistic-section-tag">{t('LogisticFaqSection:section_tag')}</span>
          <h2>{t('LogisticFaqSection:title')}</h2>
          <p>{t('LogisticFaqSection:subtitle')}</p>
        </div>

        <div className="logistic-faq-grid">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`logistic-faq-item ${activeIndex === index ? 'active' : ''}`}
            >
              <div className="logistic-faq-question" onClick={() => toggleFaq(index)}>
                <h3>{faq.question}</h3>
                <FontAwesomeIcon icon={faChevronDown} />
              </div>
              <div className="logistic-faq-answer">
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogisticFaqSection;
